<div>
  <canvas baseChart 
    [datasets]="lineChartData"
    [labels]="lineChartLabels"
    [options]="lineChartOptions"
    [legend]="lineChartLegend"
    [type]="lineChartType"
    [plugins]="lineChartPlugins">
  </canvas>
</div>
